export const browseModes = ['Sales', 'Leasing', 'Finance', 'StreetAddress'] as const;
export type BrowseMode = (typeof browseModes)[number];
